export function firstItem<T>(x: Iterable<T>) {
  for (const item of x) {
    return item
  }

  return
}
